import { render, staticRenderFns } from "./IconMobileApplicationNovikov.vue?vue&type=template&id=2be93a31&"
import script from "./IconMobileApplicationNovikov.vue?vue&type=script&lang=ts&"
export * from "./IconMobileApplicationNovikov.vue?vue&type=script&lang=ts&"
import style0 from "./IconMobileApplicationNovikov.vue?vue&type=style&index=0&id=2be93a31&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports